function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-8.7%",
  y: "-13.2%",
  width: "117.3%",
  height: "126.5%",
  filterUnits: "objectBoundingBox",
  id: "popup-dark_svg__a"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 6,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.06 0",
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  "in": "SourceAlpha",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9,
  "in": "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "shadowBlurOuter2",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.12 0",
  "in": "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter2"
}))), /*#__PURE__*/React.createElement("filter", {
  x: "-10.3%",
  y: "-46.7%",
  width: "120.5%",
  height: "206.7%",
  filterUnits: "objectBoundingBox",
  id: "popup-dark_svg__d"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 4,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0",
  "in": "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-19.3%",
  y: "-17.9%",
  width: "138.6%",
  height: "141%",
  filterUnits: "objectBoundingBox",
  id: "popup-dark_svg__f"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 4,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0",
  "in": "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h312v56a4 4 0 01-4 4H4a4 4 0 01-4-4V0z",
  id: "popup-dark_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  id: "popup-dark_svg__g",
  d: "M0 0h166v156H0z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "popup-dark_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DAEFFE",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DAEFFE",
  stopOpacity: 0,
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "popup-dark_svg__b",
  x: 0,
  y: 0,
  width: 312,
  height: 204,
  rx: 4
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#popup-dark_svg__a)",
  xlinkHref: "#popup-dark_svg__b"
});

var _ref3 = /*#__PURE__*/React.createElement("use", {
  fillOpacity: 0,
  fill: "#FFF",
  xlinkHref: "#popup-dark_svg__b"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  fill: "#DAEFFE",
  width: 312,
  height: 204,
  rx: 4
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4 0h304a4 4 0 014 4v8H0V4a4 4 0 014-4z",
  fill: "#FFF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DFE5EB",
  d: "M.5 11.5h311v1H.5z"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  fill: "#B6C1CD",
  x: 4,
  y: 4,
  width: 4,
  height: 4,
  rx: 2
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  fill: "#B6C1CD",
  x: 11,
  y: 4,
  width: 4,
  height: 4,
  rx: 2
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  fill: "#B6C1CD",
  x: 18,
  y: 4,
  width: 4,
  height: 4,
  rx: 2
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1E4FE",
  d: "M16 105h58v58H16zM90 131h58v32H90zM90 35h58v80H90zM164 105h58v58h-58zM238 124h58v39h-58zM238 35h58v73h-58zM164 35h58v54h-58zM16 35h58v54H16z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#popup-dark_svg__c)",
  d: "M10 35h292v128H10z"
});

var _ref12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  transform: "translate(0 144)"
}, /*#__PURE__*/React.createElement("use", {
  filter: "url(#popup-dark_svg__d)",
  xlinkHref: "#popup-dark_svg__e"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#popup-dark_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M260 174h40v18h-40z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M214.5 174.5h39v17h-39z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M302.44 153.5l-2.44-2.44a.75.75 0 111.06-1.06l2.44 2.44 2.44-2.44a.75.75 0 011.06 1.06l-2.44 2.44 2.44 2.44a.75.75 0 01-1.06 1.06l-2.44-2.44-2.44 2.44a.75.75 0 01-1.06-1.06l2.44-2.44z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.2,
  fill: "#FFF",
  d: "M12 156h150v6H12zM12 168h100v6H12zM12 180h40v6H12z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.2,
  fill: "#7A92A5",
  d: "M266 181h28v4h-28z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M220 181h28v4h-28z"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(73 30)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#popup-dark_svg__f)",
  xlinkHref: "#popup-dark_svg__g"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#popup-dark_svg__g"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M191 156h36v18h-36z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M197 163h24v4h-24z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(207 122)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#DFE5EB",
  width: 20,
  height: 10,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  x: 2,
  y: 2,
  width: 6,
  height: 6,
  rx: 3
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(207 100)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#DFE5EB",
  width: 20,
  height: 10,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  x: 2,
  y: 2,
  width: 6,
  height: 6,
  rx: 3
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(207 78)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#DFE5EB",
  width: 20,
  height: 10,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  x: 2,
  y: 2,
  width: 6,
  height: 6,
  rx: 3
})), /*#__PURE__*/React.createElement("path", {
  d: "M229.44 39.5L227 37.06a.75.75 0 111.06-1.06l2.44 2.44 2.44-2.44a.75.75 0 011.06 1.06l-2.44 2.44 2.44 2.44a.75.75 0 01-1.06 1.06l-2.44-2.44-2.44 2.44a.75.75 0 01-1.06-1.06l2.44-2.44z",
  fill: "#162D3D"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.2,
  fill: "#7A92A5",
  d: "M85 80h110v6H85zM85 48h80v12H85zM85 124h98v6H85zM85 102h74v6H85z"
}));

function SvgPopupDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 204,
    viewBox: "0 0 312 204"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, /*#__PURE__*/React.createElement("path", {
    d: "M0 12h312v188a4 4 0 01-4 4H4a4 4 0 01-4-4V12z",
    fillOpacity: 0.66,
    fill: "#162D3D",
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref13));
}

export default __webpack_public_path__ + "media/popup-dark.91b68db4.svg";
export { SvgPopupDark as ReactComponent };